import { Injectable } from "@angular/core";
import { FileSignature, OriginalFileNameModel } from "../types/file-signature";

@Injectable({
  providedIn: 'root'
})
export class FileStore {
  private _signature = '';
  private _containerName = '';
  private _targetFileGuid = '';
  private _fileSignatureInfo: FileSignature | null = null;
  private _accessCode = '';
  private _originalFileNames: OriginalFileNameModel[] = [];
  private _sasuri: string | null = null;
  private _downloadFileName: string | null = null;

  public getSignature(): string {
    return this._signature;
  }
  public getContainerName(): string {
    return this._containerName;
  }
  public getTargetFileGuid(): string {
    return this._targetFileGuid;
  }
  public getFileSignatureInfo(): FileSignature | null {
    return this._fileSignatureInfo;
  }
  public getAccessCode(): string {
    return this._accessCode;
  }
  public getOriginalFileNames(): OriginalFileNameModel[] {
    return this._originalFileNames;
  }
  public getSasUri(): string | null {
    return this._sasuri;
  }
  public getDownloadFileName(): string | null {
    return this._downloadFileName;
  }

  public setSignature(signature: string): void {
    this._signature = signature;
  }
  public setContainerName(containerName: string): void {
    this._containerName = containerName;
  }
  public setTargetFileGuid(fileName: string): void {
    this._targetFileGuid = fileName;
  }
  public setFileSignatureInfo(fileSignature: FileSignature): void {
    this._fileSignatureInfo = fileSignature;
  }
  public setAccessCode(accessCode: string): void {
    this._accessCode = accessCode;
  }
  public setOriginalFileNames(originalFileNames: OriginalFileNameModel[]): void {
    this._originalFileNames = originalFileNames;
  }
  public setSasUri(sasuri: string): void {
    this._sasuri = sasuri;
  }
  public setDownloadFileName(downloadFileName: string): void {
    this._downloadFileName = downloadFileName;
  }
}
